import { AppIcon } from '../../../shared/ui/AppIcon'
import { AppMenuItem } from '../../../shared/ui/AppMenuItem'
import { useMarketingAccess } from './marketing-access-context'
import './recommendation-attention.css'
export function MarketingMenuEntry({
  account,
  onClick,
}: {
  account: string
  onClick: () => void
}) {
  const { access } = useMarketingAccess()
  const current = access?.account === account && access.isCurrent()
  const available = current && access.available
  return (
    <AppMenuItem
      disabled={!available || !access?.ready}
      className={available ? 'recommendation-menu-attention' : ''}
      onClick={() => {
        if (!current || !access?.ready || !access.available) return
        onClick()
        access.open()
      }}
    >
      <AppIcon name="store" />
      <span>Актуальные акции</span>
    </AppMenuItem>
  )
}
